/*
 * jaune-protect.js
 * コンテンツの通常操作の抑止（デター）。完全な保護ではない。
 * - 右クリックメニュー（contextmenu）を無効化
 * - ドラッグ開始（dragstart）を無効化 ＝ 画像のドラッグ保存を抑止
 * リンク・ボタン・フォーム送信・キーボード操作・スクリーンリーダーには影響しない。
 * フォーム入力欄／編集可能領域では右クリック（貼り付け等）を許可する。
 */
(function () {
  'use strict';

  var EDITABLE = 'input, textarea, select, [contenteditable="true"], [contenteditable=""]';

  function inEditable(node) {
    return !!(node && typeof node.closest === 'function' && node.closest(EDITABLE));
  }

  document.addEventListener(
    'contextmenu',
    function (event) {
      if (inEditable(event.target)) return;
      event.preventDefault();
    },
    false
  );

  document.addEventListener(
    'dragstart',
    function (event) {
      event.preventDefault();
    },
    false
  );
})();
